export const TYPES = {
  SET_CATALOG_LAST_SCROLL_Y: "SET_CATALOG_LAST_SCROLL_Y",
  CLEAR_CATALOG_LAST_SCROLL_Y: "CLEAR_CATALOG_LAST_SCROLL_Y",
  SET_HOME_LAST_SCROLL_Y: "SET_HOME_LAST_SCROLL_Y",
  CLEAR_HOME_LAST_SCROLL_Y: "CLEAR_HOME_LAST_SCROLL_Y",
  SET_HOME_LISTING_PAGE_SCROLL_X: "SET_HOME_LISTING_PAGE_SCROLL_X",
  CLEAR_HOME_LISTING_PAGE_SCROLL_X: "CLEAR_HOME_LISTING_PAGE_SCROLL_X",
  SET_CATALOG_LOW_RESULTS_PRODUCT_SLIDER_SCROLL_X: "SET_CATALOG_LOW_RESULTS_PRODUCT_SLIDER_SCROLL_X",
  CLEAR_CATALOG_LOW_RESULTS_PRODUCT_SLIDER_SCROLL_X: "CLEAR_CATALOG_LOW_RESULTS_PRODUCT_SLIDER_SCROLL_X",
};

// CATALOG SCROLL NAVIGATION
export function setCatalogLastScrollY(lastScrollY) {
  return (dispatch) => {
    dispatch({ type: TYPES.SET_CATALOG_LAST_SCROLL_Y, lastScrollY });
  };
}

export function clearCatalogLastScrollY() {
  return (dispatch) => {
    dispatch({ type: TYPES.CLEAR_CATALOG_LAST_SCROLL_Y });
  };
}

export function setCatalogProductSliderLastScrollX(lastScrollX, context) {
  return (dispatch) => {
    dispatch({ type: TYPES.SET_CATALOG_LOW_RESULTS_PRODUCT_SLIDER_SCROLL_X, lastScrollX, context });
  };
}

export function clearCatalogProductSliderLastScrollX(context) {
  return (dispatch) => {
    dispatch({ type: TYPES.CLEAR_CATALOG_LOW_RESULTS_PRODUCT_SLIDER_SCROLL_X, context });
  };
}

// HOME SCROLL NAVIGATION
export function setHomeLastScrollY(lastScrollY) {
  return (dispatch) => {
    dispatch({ type: TYPES.SET_HOME_LAST_SCROLL_Y, lastScrollY });
  };
}

export function clearHomeLastScrollY() {
  return (dispatch) => {
    dispatch({ type: TYPES.CLEAR_HOME_LAST_SCROLL_Y });
  };
}

export function setHomeListingPageScrollX(lastScrollX, listingPageSlug) {
  return (dispatch) => {
    dispatch({
      type: TYPES.SET_HOME_LISTING_PAGE_SCROLL_X,
      lastScrollX,
      listingPageSlug,
    });
  };
}

export function clearHomeListingPageScrollX(listingPageSlug) {
  return (dispatch) => {
    dispatch({ type: TYPES.CLEAR_HOME_LISTING_PAGE_SCROLL_X, listingPageSlug });
  };
}
